var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.5H10L16 6.5V18.5C16 19.6 15.1 20.5 14 20.5H1.99C0.89 20.5 0 19.6 0 18.5L0.01 2.5C0.01 1.4 0.9 0.5 2 0.5ZM2 2.5V18.5H14V7.5H9V2.5H2Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.7cfb0e7775b14d404cff4e384cd9c262.svg";
export { ForwardRef as ReactComponent };